import { createSlice } from '@reduxjs/toolkit'
import {
  importUsersRolesCreateFile,
  importUsersRolesResetAlertHandler,
  importUsersRolesGetRoles,
  importUsersRolesSearchRoles,
} from './importUsersRolesThunk'

const defaultPageSize = 50
const defaultActiveSummary = 'ALL'
const initialState = {
  loading: {
    fetch: false,
    mutate: false,
  },
  alert: {},
  pageNumber: 0,
  summaries: {},
  sortBy: [],
  activeSort: {},
  filterList: [],
  activeFilters: [],
  pageSize: defaultPageSize,
  activeSummary: defaultActiveSummary,
  activeSearch: '',
  data: [],
  lookups: {},
  updatedItem: {},
  sideBar: {},
  finalPage: true,
  roles: [],
}

const importUsersRolesSlice = createSlice({
  name: 'importUsersRoles',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(importUsersRolesResetAlertHandler.fulfilled, (state) => {
      state.alert = {}
    })
    builder.addCase(importUsersRolesCreateFile.pending, (state) => {
      state.alert = {}
      state.loading.mutate = true
    })
    builder.addCase(importUsersRolesCreateFile.rejected, (state, { payload }) => {
      state.alert = payload
      state.loading.mutate = false
    })
    builder.addCase(importUsersRolesCreateFile.fulfilled, (state) => {
      state.alert = {}
      state.loading.mutate = false
    })
    builder.addCase(importUsersRolesGetRoles.pending, (state) => {
      state.alert = {}
      state.loading.fetch = true
    })
    builder.addCase(importUsersRolesGetRoles.rejected, (state, { payload }) => {
      state.alert = payload
      state.loading.fetch = false
    })
    builder.addCase(importUsersRolesGetRoles.fulfilled, (state, { payload }) => {
      state.loading.fetch = false
      state.roles = payload
    })
    builder.addCase(importUsersRolesSearchRoles.pending, (state) => {
      state.alert = {}
      state.loading.fetch = true
    })
    builder.addCase(importUsersRolesSearchRoles.rejected, (state, { payload }) => {
      state.alert = payload
      state.loading.fetch = false
    })
    builder.addCase(importUsersRolesSearchRoles.fulfilled, (state, { payload }) => {
      state.loading.fetch = false
      state.roles = payload
    })
  },
})

export const selectImportUsersRoles = ({ importUsersRoles }) => importUsersRoles
export default importUsersRolesSlice.reducer
